// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2547":"f307ccbe","2825":"b3648cad","3982":"7b6b8f18","6534":"9cde6a75","6659":"541da1c8","6924":"87d54228","6978":"e303b984","8410":"8e55c0cb"}[chunkId] + ".chunk.css";
};